import React, { ChangeEvent, FC, useMemo } from "react"
import { Text, ExclusiveChoiceDropdown, SingleLineTextInput } from "dash-styled"
import { useAppState } from "../../../../../../../Hooks/useReduxState"
import { getValue } from "../../../../../../../Models/Client/FetchState"
import {
    getQualifierMetricOperatorDisplayText,
    metricOperators
} from "../../../../../../../Models/API/QualifierModel"
import { turbine } from "neql"

interface MetricChooserProps {
    title: string
    appID: string
    cutoffMetric?: string | null
    onCutoffOperatorChange: (operator: turbine.MetricOperator) => void
    cutoffOperator?: turbine.MetricOperator | null
    cutoffValue?: string
    onCutoffValueChange: (e: ChangeEvent<HTMLInputElement>) => void
    onCutoffMetricChange: (value: string | null | undefined) => void
}

export const MetricChooser: FC<MetricChooserProps> = ({
    title,
    appID,
    onCutoffOperatorChange,
    cutoffOperator,
    cutoffValue,
    onCutoffValueChange,
    cutoffMetric,
    onCutoffMetricChange
}) => {
    const metrics = useAppState(state =>
        getValue(state.api.apps.metrics[appID])
    )

    // the metric change is not supported now, only a listis displayed
    const cutoffMetricLabels: string[] = useMemo(() => {
        if (metrics === undefined || !Array.isArray(metrics)) {
            return []
        }

        return metrics.map(metric => metric.metric_name)
    }, [metrics])

    return (
        <div className="flex items-center space-x-1">
            <Text className="my-0 flex-shrink-0" size="sm">
                {title}
            </Text>
            <ExclusiveChoiceDropdown
                className="w-84"
                size="sm"
                choices={cutoffMetricLabels}
                value={cutoffMetric}
                onClick={onCutoffMetricChange}
            />
            <ExclusiveChoiceDropdown
                className="w-48"
                size="sm"
                choices={metricOperators}
                value={cutoffOperator ?? undefined}
                renderChoice={getQualifierMetricOperatorDisplayText}
                onClick={onCutoffOperatorChange}
            />
            <SingleLineTextInput
                size="sm"
                className="w-18"
                testId="qualifiers-test-cut-off-value"
                type="number"
                transparentBg={true}
                value={cutoffValue}
                onChange={onCutoffValueChange}
                max={1}
                min={0.1}
                step={0.1}
            />
        </div>
    )
}
